import React from 'react';
import { Link } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { Hidden } from '@material-ui/core';
import { DividerSection } from '../../../global/components/layout/divider-section';
import { TcsmStates } from '../../../root/tcsm-model';
import { ClergyBioSettings } from '../../arc/models/arc-epi-props';
import { ClergyBioChurchEducation, ClergyBioRoutes, DataState, Education } from '../model/clergy-bio-app-models';
import ClergyBioComponentLoader from '../components/clergy-bio-component-loader';
import { sortTableStyles } from '../../../global/constants/theme/styles/tables/generic-sort-table';
import { ContentSpacer } from '../../../global/components/layout/generic-content-spacer';
import { WysiwygWithReactLink } from '../../../global/components/wysiwyg-with-react-link';
import { buttonStyles } from '../../../global/constants/theme/styles/components/buttonstyles';
import { ClericIcon } from '../../account-info/components/cleric-indicator';
import { headerIconStyles } from '../../../global/constants/theme/styles/components/header-icon-styles';



interface Props {
	settings: ClergyBioSettings;
	basePath: string;
}

function ClergyBioEducationReview(props: Props) {
	const tableClasses = sortTableStyles();
	const { settings, basePath } = props;
	const loadingState = useSelector<TcsmStates, DataState>(state => state?.clergyBioState?.loaded?.education);
	const education = useSelector<TcsmStates, ClergyBioChurchEducation>(state => state?.clergyBioState?.education);
	const buttonClasses = buttonStyles();
	const headerClasses = headerIconStyles();

	function Labels() {
		return (
			<Hidden xsDown>
				<div className='sort-table-row'>
					<div className='sort-table-row-cell'><p><strong>{settings?.yearLabel}</strong></p></div>
					<div className='sort-table-row-cell'><p><strong>{settings?.institutionLabel}</strong></p></div>
					<div className='sort-table-row-cell'><p><strong>{settings?.degreeLabel}</strong></p></div>
					<div className='sort-table-row-cell'><p><strong>{settings?.fieldLabel}</strong></p></div>
				</div>
			</Hidden>
		);
	}

	function TableRow(e: Education) {
		return (
			<div className='sort-table-row' key={e?.id} >
				<div className='sort-table-row-cell'>
					<Hidden smUp>
						<p><strong>{settings?.yearLabel}</strong></p>
					</Hidden>
					<p>{e?.year}</p>
				</div>
				<div className='sort-table-row-cell'>
					<Hidden smUp>
						<p><strong>{settings?.institutionLabel}</strong></p>
					</Hidden>
					<p>{e?.institution}</p>
				</div>
				<div className='sort-table-row-cell'>
					<Hidden smUp>
						<p><strong>{settings?.degreeLabel}</strong></p>
					</Hidden>
					<p>{e?.degree}</p>
				</div>
				<div className='sort-table-row-cell'>
					<Hidden smUp>
						<p><strong>{settings?.fieldLabel}</strong></p>
					</Hidden>
					<p>{e?.field}</p>
				</div>
			</div>
		);
	}

	function RenderContent() {
		return (
			<>
				<div className={headerClasses.iconHeader}>
					<ClericIcon />
					<h3>{settings?.theologicalEducationTitle}</h3>
				</div>
				<ContentSpacer>
					{
						education?.theological?.details?.length > 0 ?
							<div className={tableClasses.sortTable}>
								<Labels />
								<div className='sort-table-content'>
									{
										education?.theological?.details?.map(e => TableRow(e))
									}
								</div>
							</div>
							:
							<WysiwygWithReactLink content={settings?.noInformationText} />
					}
				</ContentSpacer>
				<div className={headerClasses.iconHeader}>
					<ClericIcon />
					<h3>{settings?.otherEducationTitle}</h3>
				</div>
				<ContentSpacer>
					{
						education?.other?.details?.length > 0 ?
							<div className={tableClasses.sortTable}>
								<Labels />
								<div className='sort-table-content'>
									{
										education?.other?.details?.map(e => TableRow(e))
									}
								</div>
							</div>
							:
							<WysiwygWithReactLink content={settings?.noInformationText} />
					}
				</ContentSpacer>
			</>
		);
	}

	return (
		<DividerSection sectionText={settings?.educationTitle} >
			<ClergyBioComponentLoader
				state={loadingState}
				content={<RenderContent />}
			/>
			<ContentSpacer>
				<Link className={buttonClasses.primaryButton} to={`${basePath}${ClergyBioRoutes.Education}`}>{settings?.updateButtonText}</Link>
			</ContentSpacer>
		</DividerSection>
	);
}


export default ClergyBioEducationReview;